import React from 'react'
import AddNewEstimates from '../../components/Functions/AddNewEstimates'

export default function BusinessEstimates() {
    const defaultFormCategory = 'Business Estimates';
    return (
        <AddNewEstimates categoryName={defaultFormCategory} />
    )
}
